module.exports = __webpack_public_path__ + "static/media/down-rating-coffee.063d5b24.svg";